import { render, staticRenderFns } from "./BenefitStatusChip.vue?vue&type=template&id=3de6b892"
import script from "./BenefitStatusChip.vue?vue&type=script&lang=js"
export * from "./BenefitStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports